/*
 *
 * EmailVerification actions
 *
 */
// @flow

import {
  VERIFY_EMAIL,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_FAILURE,
} from './EmailVerification.constants';

export const verifyEmail = () => ({
  type: VERIFY_EMAIL,
});
export const verifyEmailSuccess = () => ({
  type: VERIFY_EMAIL_SUCCESS,
});
export const verifyEmailFailure = error => ({
  type: VERIFY_EMAIL_FAILURE,
  error,
});

export default [verifyEmail()];
